/**
 * Computes the duration in hours between two "HH:mm" times. Handles routes
 * that cross midnight (end time earlier than start time) by treating the
 * end time as being on the next day.
 */
export const computeRouteDurationHours = (startTime: string, endTime: string): number => {
  const [startHour, startMinute] = startTime.split(':').map(Number);
  const [endHour, endMinute] = endTime.split(':').map(Number);
  const startMinutes = startHour * 60 + startMinute;
  let endMinutes = endHour * 60 + endMinute;
  if (endMinutes <= startMinutes) {
    endMinutes += 24 * 60;
  }
  return (endMinutes - startMinutes) / 60;
};
